
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { ProcedureTemplateOverviewDto_$reflection } from "../../Shared/Procedure.js";
import { record_type, union_type, class_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { RequestedValue$1_$reflection } from "../../Shared/Shared.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ProcedureTemplatesFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("ProcedureTemplate.Overview.Types.Msg", [], Msg, () => [[["Item", list_type(ProcedureTemplateOverviewDto_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

export class State extends Record {
    constructor(ProcedureTemplates) {
        super();
        this.ProcedureTemplates = ProcedureTemplates;
    }
}

export function State_$reflection() {
    return record_type("ProcedureTemplate.Overview.Types.State", [], State, () => [["ProcedureTemplates", RequestedValue$1_$reflection(list_type(ProcedureTemplateOverviewDto_$reflection()))]]);
}

